import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled, { useTheme } from 'styled-components'
import { em } from 'polished'
import { ModalState, Button, Icon } from '@binance-chain/honeycomb'

import { setShowIpValidation } from '../../redux/global/action'

const Notice = styled.div`
  align-self: flex-start;
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};
`

const CountryList = styled.div`
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced)};
  margin-top: ${({ theme }) => em(theme.honeycomb.size.small)};
`

const Website = styled.a`
  color: ${({ theme }) => theme.honeycomb.color.primary.normal};
  padding: 0 ${({ theme }) => em(theme.honeycomb.size.micro)};

  &:hover {
    color: ${({ theme }) => theme.honeycomb.color.primary.active};
  }
`

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => em(theme.honeycomb.size.increased)};
`

const StyledModalState = styled(ModalState)`
  [data-testid='close-btn'] {
    display: none;
  }
`

export default () => {
  const dispatch = useDispatch()
  const {
    globalData: { isIpValid, isShowIpValidation },
    i18n: { data: i18nData },
  } = useSelector(state => state)
  const theme = useTheme()

  const onClose = useCallback(() => {
    dispatch(setShowIpValidation(false))
  }, [dispatch])

  return (
    <StyledModalState
      open={!isIpValid && isShowIpValidation}
      icon={<Icon.WarningTriangleSolid color={theme.honeycomb.color.danger.normal} />}
      title=""
      description=""
      closeOnBackgroundClick={false}
    >
      <Notice>
        {i18nData && i18nData['blocked.country.notice-1']
          ? i18nData['blocked.country.notice-1']
          : `Users in the following countries or regions are currently unable to access`}
        <Website href="https://www.binance.org" target="_blank">
          www.binance.org
        </Website>
        {i18nData && i18nData['blocked.country.notice-2']
          ? i18nData['blocked.country.notice-2']
          : `service:`}
      </Notice>

      <CountryList>
        {i18nData && i18nData['blocked.country.list']
          ? i18nData['blocked.country.list']
          : `United States of America, China, Albania, Bosnia and Herzegovina, Belarus, Congo (DRC), Côte
            d'Ivoire, Crimea, Cuba, Iraq, Iran, North Korea, Liberia, Macedonia, Myanmar, Serbia,
            Sudan, Syria, Zimbabwe.`}{' '}
      </CountryList>

      <StyledButton variant="primary" shape="fit" onClick={() => onClose()}>
        {i18nData && i18nData['blocked.country.understand']
          ? i18nData['blocked.country.understand']
          : `I understand`}
      </StyledButton>
    </StyledModalState>
  )
}
